import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { InputAdornment } from '@mui/material'
import { format } from 'date-fns'

import { formatDateInput } from '../../util/strings'
import { FlexColumn, FlexRow } from '../styles/Containers'
import FormInput from '../inputFields/FormInput'
import FormattedInput from '../inputFields/FormattedInput'
import TimeSelector from '../inputFields/TimeSelector'
import CalendarDateButton from '../common/CalendarDateButton'

function ActivityForm() {
  const { getValues, watch, setValue } = useFormContext()
  const [currentDate, setCurrentDate] = useState()

  const date = watch('date')
  const time = watch('time')

  useEffect(() => {
    if (!date) setValue('date', format(new Date(), 'MMM-dd-yyyy'))
    if (!currentDate && date) setCurrentDate(format(getValues('date'), 'MMM-dd-yyyy'))
    if (!time) setValue('time', new Date())
  }, [])

  useEffect(() => {
    setCurrentDate(getValues('date') || format(new Date(), 'MMM-dd-yyyy'))
  }, [date])

  const handleConfirmDate = date => setValue('date', format(date, 'MMM-dd-yyyy'))

  return (
    <FlexColumn>
      <FormInput id="label" label="Label" required />
      <FlexRow width="100%">
        {currentDate !== undefined && (
          <FormattedInput
            id="date"
            label="Date"
            basis="50%"
            handleFormatValue={formatDateInput}
            tooltip="Format example: May-25-2025"
            required
            inputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CalendarDateButton initialValue={new Date(currentDate)} title="Start Date" onConfirm={handleConfirmDate} />
                </InputAdornment>
              )
            }}
          />
        )}
        <TimeSelector id="time" label="Time" basis="50%" required />
      </FlexRow>
    </FlexColumn>
  )
}

export default ActivityForm
